/* Copyright (c) 2020-present CloudIO Inc */

import { Box, Typography } from '@mui/material';

export default function StepContainer({
  children,
  index,
  title,
}: {
  title: React.ReactNode;
  children?: React.ReactNode;
  index: number;
}) {
  return (
    <Box
      sx={{
        maxWidth: '720px',
        width: '100%',
        m: 2,
        p: 2,
        borderRadius: '20px',
        bgcolor: 'background.paper',
        boxShadow:
          '0 0 #0000,0 0 #0000,0 1px 3px 0 rgba(15,23,42,.1),0 1px 2px -1px rgba(15,23,42,.1)',
        display: 'flex',
        flexDirection: 'column',
        '& .showonhover': { visibility: 'hidden' },
        '&:hover .showonhover': { visibility: 'visible' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexDirection: 'row',
          flexWrap: 'nowrap',
        }}
      >
        <Box
          aria-label={`Step ${index}`}
          sx={{
            bgcolor: 'rgb(238 242 255)',
            borderRadius: '50%',
            p: 1,
            width: '2.5rem',
            height: '2.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'primary.main',
            flexShrink: 0,
          }}
        >
          <Typography variant="subtitle1" aria-hidden="true" fontWeight="bold">
            {index}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            flexDirection: 'row',
            flexWrap: 'nowrap',
          }}
        >
          {title}
        </Box>
      </Box>
      {children}
    </Box>
  );
}
